"use client";

import { usePathname, useRouter } from "@/i18n/navigation";
import { routing, type Locale } from "@/i18n/routing";
import { useLocale, useTranslations } from "next-intl";

export function LocaleSwitcher() {
  const router = useRouter();
  const pathname = usePathname();
  const currentLocale = useLocale();
  const t = useTranslations("LocaleSwitcher");

  function onSwitch(next: Locale) {
    router.push(pathname, { locale: next });
  }

  return (
    <div className="flex items-center rounded-full border border-slate-200 bg-slate-50 p-0.5 text-sm font-semibold">
      {routing.locales.map((locale) => (
        <div
          key={locale}
          tabIndex={0}
          onClick={() => onSwitch(locale)}
          aria-current={currentLocale === locale ? "true" : undefined}
          className={`px-3 py-0.5 rounded-full transition-all rtl:font-display! text-sm! ${
            currentLocale === locale
              ? "bg-primary text-white shadow-sm"
              : "text-slate-500 hover:text-slate-700"
          }`}
        >
          {t(locale)}
        </div>
      ))}
    </div>
  );
}
